import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import CUIHomepageCard from 'connect-dot-com-ui-components/Components/CUIHomepageCard/CUIHomepageCard';
import CUIHomepageCardDescriptionSection from 'connect-dot-com-ui-components/Components/CUIHomepageCard/CUIHomepageCardDescriptionSection';
import CUIHomepageCardImageSection from 'connect-dot-com-ui-components/Components/CUIHomepageCard/CUIHomepageCardImageSection';
import { generateBlockColorBackgroundProps, generateGradientBackgroundProps, HomepageCardBackgroundGradient } from 'connect-dot-com-ui-components/Components/CUIHomepageCard/utils/backgroundGradients';
import CUISignupButton from 'connect-dot-com-ui-components/Components/CUISignupButton/CUISignupButton';
import { CUIVStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { trackPageview } from '../utils/usageTracker'; // @ts-expect-error ts-migrate(7016) NOFIX

import profileCardsStacked from 'bender-url!../../images/homepageCardImages/profile-cards-stacked.svg'; // @ts-expect-error ts-migrate(7016) NOFIX

import academyScreenshots from 'bender-url!../../images/homepageCardImages/academy-screenshots.png'; // @ts-expect-error ts-migrate(7016) NOFIX

import communityUniverse from 'bender-url!../../images/homepageCardImages/community-universe.png'; // @ts-expect-error ts-migrate(7016) NOFIX

import profileBackground from 'bender-url!../../images/homepageCardImages/profile-bg.svg'; // @ts-expect-error ts-migrate(7016) NOFIX

import academyBackground from 'bender-url!../../images/homepageCardImages/academy-bg.svg';
export default function HomepageContent() {
  useEffect(() => {
    trackPageview('homepage');
  }, []);
  return /*#__PURE__*/_jsxs(CUIVStack, {
    spacing: 8,
    "data-test-id": "homepage-card-stack",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "HOME_LOAD"
    }), /*#__PURE__*/_jsx(CUIHomepageCard, {
      "data-test-id": "homepage-card",
      mediaSide: "right",
      media: /*#__PURE__*/_jsx(CUIHomepageCardImageSection, Object.assign({
        src: academyScreenshots,
        alt: I18n.text('app.homepage.cards.academy.imgAlt')
      }, generateBlockColorBackgroundProps(academyBackground))),
      description: /*#__PURE__*/_jsx(CUIHomepageCardDescriptionSection, Object.assign({
        cta: /*#__PURE__*/_jsx(CUISignupButton, {
          trackingIdentifier: "academy-card"
        }),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.cards.academy.title"
        }),
        bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.cards.academy.bodyText"
        })
      }, generateGradientBackgroundProps(HomepageCardBackgroundGradient.carnabyMacaron, true)))
    }), /*#__PURE__*/_jsx(CUIHomepageCard, {
      "data-test-id": "homepage-card",
      mediaSide: "right",
      media: /*#__PURE__*/_jsx(CUIHomepageCardImageSection, Object.assign({
        src: communityUniverse,
        alt: I18n.text('app.homepage.cards.community.imgAlt')
      }, generateGradientBackgroundProps(HomepageCardBackgroundGradient.pinkToOrangeishVertical))),
      description: /*#__PURE__*/_jsx(CUIHomepageCardDescriptionSection, Object.assign({
        isComingSoon: true,
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.cards.community.title"
        }),
        bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.cards.community.bodyText"
        }),
        cta: /*#__PURE__*/_jsx(CUISignupButton, {
          trackingIdentifier: "community-card"
        })
      }, generateBlockColorBackgroundProps()))
    }), /*#__PURE__*/_jsx(CUIHomepageCard, {
      "data-test-id": "homepage-card",
      mediaSide: "right",
      media: /*#__PURE__*/_jsx(CUIHomepageCardImageSection, Object.assign({
        src: profileCardsStacked,
        alt: I18n.text('app.homepage.cards.profile.imgAlt')
      }, generateBlockColorBackgroundProps(profileBackground))),
      description: /*#__PURE__*/_jsx(CUIHomepageCardDescriptionSection, Object.assign({
        isComingSoon: true,
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.cards.profile.title"
        }),
        bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.homepage.cards.profile.bodyText"
        }),
        cta: /*#__PURE__*/_jsx(CUISignupButton, {
          trackingIdentifier: "profile-card"
        })
      }, generateGradientBackgroundProps(HomepageCardBackgroundGradient.cherryBlossomCarnaby, true)))
    })]
  });
}